module.exports = __webpack_public_path__ + "media/images/arrow-right-black-4b47037c362e5c448b7928fb25ac18cc.png";